<template>
  <div class="app-container">
    <div class="resizable-layout">
      <!-- 左侧车辆树 -->
      <div class="tree-panel" :style="{ width: treeWidth + 'px' }">
        <car-tree-div ref="carTreeDiv" @selectCar="handleSelectCar"></car-tree-div>
      </div>

      <!-- 拖拽分隔线 -->
      <div class="resize-handle" @mousedown="startResize" @mouseover="showResizeCursor" @mouseleave="hideResizeCursor">
        <div class="resize-line"></div>
      </div>

      <!-- 右侧内容区域 -->
      <div class="content-panel" :style="{ width: 'calc(100% - ' + (treeWidth + 10) + 'px)' }">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ carCreateFeeInfo.carNum || $t('carCreateFee.vehicleCharging') }}</span>
            <div class="header-tools">
              <el-button size="small" @click="_openCarFeeImportExcel">
                <i class="el-icon-download"></i>
                {{ $t('carCreateFee.customTemplate') }}
              </el-button>
              <el-button size="small" @click="_openDoCreateCarFee">
                <i class="el-icon-plus"></i>
                {{ $t('carCreateFee.customCreate') }}
              </el-button>
              <el-button size="small" @click="_toBatchCreateFee">
                <i class="el-icon-plus"></i>
                {{ $t('carCreateFee.batchCreate') }}
              </el-button>
            </div>
          </div>

          <el-tabs v-model="carCreateFeeInfo._currentTab" @tab-click="changeTab(carCreateFeeInfo._currentTab)">
            <!-- 欠费（第一个tab） -->
            <el-tab-pane :label="$t('carCreateFee.oweFee')" name="simplifyOweFee">
              <simplify-owe-fee v-if="carCreateFeeInfo._currentTab === 'simplifyOweFee'" ref="simplifyOweFee"
                :key="'simplifyOweFee' + carCreateFeeInfo.carId"></simplify-owe-fee>
            </el-tab-pane>

            <!-- 车辆费 -->
            <el-tab-pane :label="$t('carCreateFee.carFee')" name="simplifyCarFee">
              <simplify-car-fee v-if="carCreateFeeInfo._currentTab === 'simplifyCarFee'" ref="simplifyCarFee"
                :key="'simplifyCarFee' + carCreateFeeInfo.carId"></simplify-car-fee>
            </el-tab-pane>

            <!-- 缴费历史 -->
            <el-tab-pane :label="$t('carCreateFee.paymentHistory')" name="simplifyHisFee">
              <simplify-his-fee v-if="carCreateFeeInfo._currentTab === 'simplifyHisFee'" ref="simplifyHisFee"
                :key="'simplifyHisFee' + carCreateFeeInfo.carId"
                @viewFeeDetail="_viewFeeDetail"></simplify-his-fee>
            </el-tab-pane>

            <!-- 补打收据 -->
            <el-tab-pane :label="$t('carCreateFee.receiptReprint')" name="simplifyFeeReceipt">
              <simplify-fee-receipt v-if="carCreateFeeInfo._currentTab === 'simplifyFeeReceipt'" ref="simplifyFeeReceipt"
                :key="'simplifyFeeReceipt' + carCreateFeeInfo.carId"></simplify-fee-receipt>
            </el-tab-pane>

            <!-- 应收票据（打印与收款） -->
            <el-tab-pane label="应收票据" name="simplifyPreReceipt">
              <simplify-pre-receipt v-if="carCreateFeeInfo._currentTab === 'simplifyPreReceipt'" ref="simplifyPreReceipt"
                :key="'simplifyPreReceipt' + carCreateFeeInfo.carId"></simplify-pre-receipt>
            </el-tab-pane>

            <!-- 催缴（需有房屋） -->
            <el-tab-pane v-if="carCreateFeeInfo.roomId" :label="$t('carCreateFee.callable')" name="simplifyCallable">
              <simplify-callable v-if="carCreateFeeInfo._currentTab === 'simplifyCallable'" ref="simplifyCallable"
                :key="'simplifyCallable' + carCreateFeeInfo.carId"></simplify-callable>
            </el-tab-pane>

            <!-- 业主（需有业主） -->
            <el-tab-pane v-if="carCreateFeeInfo.ownerId" :label="$t('carCreateFee.owner')" name="carDetailOwner">
              <car-detail-owner v-if="carCreateFeeInfo._currentTab === 'carDetailOwner'" ref="carDetailOwner"
                :key="'carDetailOwner' + carCreateFeeInfo.carId"></car-detail-owner>
            </el-tab-pane>

            <!-- 费用详情 -->
            <el-tab-pane v-if="carCreateFeeInfo._detailFeeId" :label="$t('carCreateFee.feeDetail')" name="feeDetailHisFee">
              <fee-detail-his-fee v-if="carCreateFeeInfo._currentTab === 'feeDetailHisFee'" ref="feeDetailHisFee"
                :key="'feeDetailHisFee' + carCreateFeeInfo._detailFeeId"></fee-detail-his-fee>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </div>

    <!-- 子组件 -->
    <export-car-fee-import-excel ref="exportCarFeeImportExcel" />
    <do-import-create-fee ref="doImportCreateFee" />
    <car-create-fee-add ref="carCreateFeeAdd" @success="handleBatchCreateSuccess" />
  </div>
</template>

<script>
import CarTreeDiv from '@/components/car/CarTreeDiv'
import SimplifyCarFee from '@/components/simplify/simplifyCarFee'
import SimplifyOweFee from '@/components/simplify/simplifyOweFee'
import SimplifyHisFee from '@/components/fee/simplifyHisFee'
import SimplifyFeeReceipt from '@/components/fee/simplifyFeeReceipt'
import SimplifyCallable from '@/components/fee/simplifyCallable'
import CarDetailOwner from '@/components/fee/carDetailOwner'
import FeeDetailHisFee from '@/components/fee/feeDetailHisFee'
import SimplifyPreReceipt from '@/components/simplify/simplifyPreReceipt'
import ExportCarFeeImportExcel from '@/components/fee/exportCarFeeImportExcel'
import DoImportCreateFee from '@/components/fee/doImportCreateFee'
import CarCreateFeeAdd from '@/components/fee/carCreateFeeAdd'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'CarCreateFeeList',
  components: {
    CarTreeDiv,
    SimplifyCarFee,
    SimplifyOweFee,
    SimplifyHisFee,
    SimplifyFeeReceipt,
    SimplifyCallable,
    CarDetailOwner,
    FeeDetailHisFee,
    SimplifyPreReceipt,
    ExportCarFeeImportExcel,
    DoImportCreateFee,
    CarCreateFeeAdd
  },
  data() {
    return {
      carCreateFeeInfo: {
        carId: '',
        carNum: '',
        ownerId: '',
        ownerName: '',
        roomId: '',
        roomName: '',
        _currentTab: 'simplifyOweFee',
        _detailFeeId: ''
      },
      communityId: '',
      treeWidth: 220,
      minTreeWidth: 160,
      maxTreeWidth: 600,
      isResizing: false,
      startX: 0,
      startWidth: 0
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.restoreTreeWidth()
  },
  mounted() {
    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup', this.onMouseUp)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onMouseMove)
    document.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    handleSelectCar(carData) {
      this.carCreateFeeInfo.carId = carData.carId
      this.carCreateFeeInfo.carNum = carData.carNum
      this.carCreateFeeInfo.ownerId = carData.ownerId || ''
      this.carCreateFeeInfo.ownerName = carData.ownerName || ''
      this.carCreateFeeInfo.roomId = carData.roomId || ''
      this.carCreateFeeInfo.roomName = ''
      this.carCreateFeeInfo._detailFeeId = ''

      // 如果当前tab因为条件不满足被隐藏，切换到默认tab
      const validTabs = ['simplifyOweFee', 'simplifyCarFee', 'simplifyHisFee', 'simplifyFeeReceipt', 'simplifyPreReceipt']
      if (this.carCreateFeeInfo.roomId) {
        validTabs.push('simplifyCallable')
      }
      if (this.carCreateFeeInfo.ownerId) {
        validTabs.push('carDetailOwner')
      }

      if (!validTabs.includes(this.carCreateFeeInfo._currentTab)) {
        this.carCreateFeeInfo._currentTab = 'simplifyCarFee'
      }

      this.changeTab(this.carCreateFeeInfo._currentTab)
    },

    changeTab(tab) {
      this.carCreateFeeInfo._currentTab = tab
      setTimeout(() => {
        if (this.$refs[tab]) {
          if (tab === 'feeDetailHisFee') {
            this.$refs[tab].open({ feeId: this.carCreateFeeInfo._detailFeeId })
            return
          }
          if (tab === 'carDetailOwner') {
            this.$refs[tab].open({
              ownerId: this.carCreateFeeInfo.ownerId,
              ownerName: this.carCreateFeeInfo.ownerName,
              roomId: this.carCreateFeeInfo.roomId
            })
            return
          }
          // 通用调用：传递车辆相关信息
          this.$refs[tab].open({
            carId: this.carCreateFeeInfo.carId,
            carNum: this.carCreateFeeInfo.carNum,
            ownerId: this.carCreateFeeInfo.ownerId,
            ownerName: this.carCreateFeeInfo.ownerName,
            roomId: this.carCreateFeeInfo.roomId,
            roomName: this.carCreateFeeInfo.roomName
          })
        }
      }, 500)
    },

    _viewFeeDetail(detail) {
      this.carCreateFeeInfo._detailFeeId = detail.feeId
      this.$nextTick(() => {
        this.changeTab('feeDetailHisFee')
      })
    },

    _openCarFeeImportExcel() {
      this.$refs.exportCarFeeImportExcel.open()
    },

    _toBatchCreateFee() {
      this.$refs.carCreateFeeAdd.open({ isMore: true })
    },

    handleBatchCreateSuccess() {
      // 批量创建成功后刷新当前tab
      if (this.$refs[this.carCreateFeeInfo._currentTab]) {
        this.$refs[this.carCreateFeeInfo._currentTab].open({
          carId: this.carCreateFeeInfo.carId,
          carNum: this.carCreateFeeInfo.carNum,
          ownerId: this.carCreateFeeInfo.ownerId,
          ownerName: this.carCreateFeeInfo.ownerName,
          roomId: this.carCreateFeeInfo.roomId,
          roomName: this.carCreateFeeInfo.roomName
        })
      }
    },

    _openDoCreateCarFee() {
      this.$refs.doImportCreateFee.open()
    },


    restoreTreeWidth() {
      const savedWidth = localStorage.getItem('carCreateFeeTreeWidth')
      if (savedWidth) {
        const width = parseInt(savedWidth)
        if (width >= this.minTreeWidth && width <= this.maxTreeWidth) {
          this.treeWidth = width
        }
      }
    },

    saveTreeWidth() {
      localStorage.setItem('carCreateFeeTreeWidth', this.treeWidth.toString())
    },

    startResize(event) {
      event.preventDefault()
      this.isResizing = true
      this.startX = event.clientX
      this.startWidth = this.treeWidth
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'
    },

    onMouseMove(event) {
      if (!this.isResizing) return
      const deltaX = event.clientX - this.startX
      const newWidth = this.startWidth + deltaX
      if (newWidth >= this.minTreeWidth && newWidth <= this.maxTreeWidth) {
        this.treeWidth = newWidth
      }
    },

    onMouseUp() {
      if (this.isResizing) {
        this.isResizing = false
        this.saveTreeWidth()
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
      }
    },

    showResizeCursor() {
      if (!this.isResizing) {
        document.body.style.cursor = 'col-resize'
      }
    },

    hideResizeCursor() {
      if (!this.isResizing) {
        document.body.style.cursor = ''
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  height: calc(100vh - 120px);
  overflow: hidden;
}

.resizable-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.tree-panel {
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  border: 1px solid #e4e7ed;
}

.content-panel {
  overflow-y: auto;
}

.resize-handle {
  width: 10px;
  cursor: col-resize;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resize-handle:hover .resize-line {
  background-color: #409eff;
}

.resize-line {
  width: 2px;
  height: 30px;
  background-color: #dcdfe6;
  border-radius: 1px;
  transition: background-color 0.2s;
}

.header-tools {
  float: right;
}
</style>
